module.exports = __webpack_public_path__ + "img/FAQ-1.eb34eb81.gif";